<script>
  import { onMount } from 'svelte';
  import { getApiUrl } from '../api';
  import { authFetch } from '../authService';
  import { Link } from 'svelte-routing';

  let promotions = [];
  let isLoading = true;
  let page = 1;
  const pageSize = 10;
  let totalPages = 1;

  onMount(fetchData);

  async function fetchData() {
    isLoading = true;
    try {
      const res = await authFetch(getApiUrl(`/admin/promotions/missing-formulas?page=${page}&pageSize=${pageSize}`));
      const data = await res.json();
      promotions = data.data;
      totalPages = data.totalPages;
    } catch(e) {
      console.error(e);
    } finally {
      isLoading = false;
    }
  }

  async function toggleRequirement(promo) {
      if(!confirm(`Mark "${promo.name}" as NOT needing a formula? It will disappear from this list.`)) return;

      try {
          const res = await authFetch(getApiUrl(`/admin/promotions/${promo._id}/formula-requirement`), {
              method: 'PUT',
              body: JSON.stringify({ notRequired: true })
          });
          if(res.ok) {
              fetchData(); // Refresh list
          }
      } catch(e) { alert(e.message); }
  }

  function nextPage() { if(page < totalPages) { page++; fetchData(); } }
  function prevPage() { if(page > 1) { page--; fetchData(); } }
</script>

<div class="admin-container">
    <h2>Promotions Missing Reward Formulas</h2>
    <p class="hint">These active promotions do not have calculation rules linked. Add rules or mark as not required.</p>

    {#if isLoading}
        <p>Loading...</p>
    {:else if promotions.length === 0}
        <div class="empty">All set! No pending formulas found.</div>
    {:else}
        <table>
            <thead>
                <tr>
                    <th>Promotion</th>
                    <th>Created By</th>
                    <th>Date</th>
                    <th>Actions</th>
                </tr>
            </thead>
            <tbody>
                {#each promotions as p}
                    <tr>
                        <td>
                            <strong>{p.name}</strong><br/>
                            <small>{p._id}</small>
                        </td>
                        <td>{p.createdByUserName || 'Unknown'}</td>
                        <td>{new Date(p.lastUpdated).toLocaleDateString()}</td>
                        <td class="actions">
                            <Link to={`/edit/${p._id}`} class="btn edit">Edit / Add Rule</Link>
                            <button class="btn ignore" on:click={() => toggleRequirement(p)}>Mark Not Req.</button>
                        </td>
                    </tr>
                {/each}
            </tbody>
        </table>
        
        <div class="pagination">
            <button disabled={page <= 1} on:click={prevPage}>Prev</button>
            <span>Page {page} of {totalPages}</span>
            <button disabled={page >= totalPages} on:click={nextPage}>Next</button>
        </div>
    {/if}
</div>

<style>
    .admin-container { max-width: 1000px; margin: 2rem auto; padding: 0 1rem; }
    .hint { color: #666; margin-bottom: 2rem; }
    table { width: 100%; border-collapse: collapse; background: white; box-shadow: 0 2px 5px rgba(0,0,0,0.05); }
    th, td { padding: 1rem; text-align: left; border-bottom: 1px solid #eee; }
    th { background: #f8f9fa; }
    .actions { display: flex; gap: 0.5rem; align-items: center; }
    .btn { padding: 0.5rem 1rem; border-radius: 4px; text-decoration: none; font-size: 0.9rem; cursor: pointer; border: none; }
    .edit { background: #007bff; color: white; }
    .ignore { background: #6c757d; color: white; }
    .empty { padding: 3rem; text-align: center; background: #e9ecef; border-radius: 8px; font-weight: bold; color: #28a745; }
    .pagination { margin-top: 1rem; display: flex; justify-content: flex-end; gap: 1rem; align-items: center; }
    small { color: #999; font-size: 0.8rem; }
</style>